import { createModel } from 'xstate/lib/model';

import baseEvents from 'common/bento/config/baseEvents';

import { CapitalDepositEUBankAccountSchema } from '../libs/capitalDepositEUBankAccountSchema';

interface CapitalDepositEUBankAccountModuleData {
  isMandatee: boolean;
}

export type Context = {
  formData: CapitalDepositEUBankAccountSchema | undefined;
  getModuleData: () => CapitalDepositEUBankAccountModuleData;
};

const context: Context = {
  // We want to keep the form state in the context so that
  // when user answers "No" and then comes back to the form page
  // the "No" option is still selected
  formData: undefined,

  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },
};

const model = createModel(
  context,

  {
    events: {
      ...baseEvents,
      SUBMIT: (values: CapitalDepositEUBankAccountSchema) => ({ values }),
    },
  },
);

export default model;

export type Model = typeof model;
